export const formatCurrencyRate = (value) => (
  value === null || value === undefined ? 'не задан' : `${Number(value).toFixed(2)} ₽`
);
